/* tslint:disable */
/* eslint-disable */
/**
 * Gallaudet
 * A set of APIs to allow seamless integration of the NUSA Roblox game
with Google Classrooms.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated.
 * Do not edit the class manually.
 */
import { exists, mapValues } from './model-utils';

/**
 * 
 * @export
 * @interface DelegateGoogleClassroomAccessResponseContent
 */
export interface DelegateGoogleClassroomAccessResponseContent {
    /**
     * 
     * @type {string}
     * @memberof DelegateGoogleClassroomAccessResponseContent
     */
    message: string;
}


/**
 * Check if a given object implements the DelegateGoogleClassroomAccessResponseContent interface.
 */
export function instanceOfDelegateGoogleClassroomAccessResponseContent(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "message" in value;
    return isInstance;
}

export function DelegateGoogleClassroomAccessResponseContentFromJSON(json: any): DelegateGoogleClassroomAccessResponseContent {
    return DelegateGoogleClassroomAccessResponseContentFromJSONTyped(json, false);
}

export function DelegateGoogleClassroomAccessResponseContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): DelegateGoogleClassroomAccessResponseContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'message': json['message'],
    };
}

export function DelegateGoogleClassroomAccessResponseContentToJSON(value?: DelegateGoogleClassroomAccessResponseContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'message': value.message,
    };
}

